import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import AccessContext from '../../context/AccessContext/AccessContext';
import ButtonWhiteReturn from '../Buttons/ButtonWhiteReturn';
import EmployeeInfoCard from '../Employee/EmployeeInfoCard';
import { t } from 'i18next';
import AccessVehiclesContext from '../../context/AccessVehiclesContext/AccessVehiclesContext';
import VisitInfoCard from '../Visit/VisitInfoCard';
import useWindowSize from '../../customHooks/useWindowSize';
import { getTenantInfoByKey } from '../../helpers/helpers';
import AccessPersonToVisitContext from '../../context/AccessPersonToVisitContext/AccessPersonToVisitContext';
import AccessAreaContext from '../../context/AccessAreaContext/AccessAreaContext';
import AccessEquipmentContext from '../../context/AccessEquipment/AccessEquipmentContext';

const NavAccessBody = () => {
    const { accessState, clean } = useContext(AccessContext);
    const { step, employee, type, visit } = accessState

    const { cleanAccessVehiclesState } = useContext(AccessVehiclesContext);
    const { cleanAccessPersonToVisitState } = useContext(AccessPersonToVisitContext);
    const { cleanAccessAreaState } = useContext(AccessAreaContext);
    const { cleanAccessEquipmentState } = useContext(AccessEquipmentContext);

    const isExit = ['EXIT_VISIT', 'EXIT'].some(typeOption => typeOption === type);

    const { windowWidth } = useWindowSize();

    const navigate = useNavigate();

    const mobileSteps = {
        'CONTRACTOR_SELECTABLE': t('SELECT_CONTRACT'),
        'ACCESS_WITH': isExit ? t('PERSON_EXIT_WITH') : t('PERSON_ENTRY_WITH'),
        'VEHICLES_SELECTABLE': t('SELECT_VEH'),
        'SELECT_EQUIPMENT_OR_TOOLS': t('SELECT_WITH_EQUIPMENT_OR_TOOLS'),
        'VISIT_VEHICLE_FORM': t('WRITE_VISIT_VEHICLE_DATA'),
        'VISIT_FORM': t('WRITE_VISIT_DATA'),
        'SELECT_AREA': `${t('SELECT')} ${getTenantInfoByKey('area_name')}`,
        'SELECT_PERSON_TO_VISIT': t('SELECT_PERSON_TO_VISIT'),
        'DETAIL': isExit ? t('EXIT_DETAIL') : t('ENTRY_DETAIL'),
        'SUCCESS_MOVEMENT': null,
        'ERROR_MOVEMENT': null,
        'EMPLOYEE_NO_ACCESS': null,
    }

    const defaultSteps = {
        'ACCESS': t('ENTRY'),
        'ACCESS_VISIT': t('ENTRY'),
        'EXIT': t('DEPARTURE'),
        'EXIT_VISIT': t('DEPARTURE')
    }

    const canShowVisitInfo = ['ACCESS_WITH', 'VISIT_VEHICLE_FORM', 'SELECT_AREA', 'SELECT_PERSON_TO_VISIT', 'SELECT_EQUIPMENT_OR_TOOLS'].some(validStep => validStep === step) && visit;

    const canShowEmployeeInfo = ['ACCESS_WITH', 'VEHICLES_SELECTABLE', 'SELECT_AREA', 'SELECT_PERSON_TO_VISIT', 'EMPLOYEE_NO_ACCESS', 'SELECT_EQUIPMENT_OR_TOOLS'].some(validStep => validStep === step) && employee;

    const currentStep = step === '' ? t('VALIDATING') : windowWidth >= 576 ? defaultSteps[type] : mobileSteps[step];

    const getBackAndClean = () => {
        navigate('/dashboard');
        clean();
        cleanAccessVehiclesState();
        cleanAccessPersonToVisitState();
        cleanAccessAreaState();
        cleanAccessEquipmentState();
    }

    return (
        <div className={['SUCCESS_MOVEMENT', 'ERROR_MOVEMENT'].some(validStep => validStep === step) ? '' : 'd-flex flex-column flex-sm-column-reverse gap-4'}>

            {canShowEmployeeInfo && (
                <EmployeeInfoCard
                    employee={employee}
                />
            )}

            {canShowVisitInfo && (
                <VisitInfoCard
                    visit={visit}
                />
            )}

            {
                currentStep !== null ?
                    <ButtonWhiteReturn
                        title={currentStep}
                        onClick={getBackAndClean}
                        alingment={windowWidth >= 576 ? 'gap-2' : 'justify-content-between'}
                    />
                    :
                    null
            }
        </div>
    )
}

export default NavAccessBody